// extracted by mini-css-extract-plugin
export default {"tx":"b33c270de1","line":"d630981332"};